export default __webpack_public_path__ + "static/media/Group607.12b166f6.png";